<script setup lang="ts">
const colorMode = useColorMode();
const logoURL = ref("/imgs/light-small-logo.png");
const showIcon = ref(false);

const locale = useNuxtApp().$i18n.locale;
watch(colorMode, () => {
  switch (colorMode.preference) {
    case "light":
      logoURL.value = "/imgs/light-small-logo.png";
      break;
    default:
      logoURL.value = "/imgs/dark-small-logo.png";
  }
});
onMounted(() => {
  const showBanner = localStorage.getItem("banner-showed");
  if (showBanner) {
    const response = JSON.parse(showBanner);
    const currentDate = new Date();
    const expiresDate = new Date(response.expires);
    if (currentDate.getTime() > expiresDate.getTime()) {
      showIcon.value = true;
    }
  } else {
    showIcon.value = true;
  }
  switch (colorMode.preference) {
    case "light":
      logoURL.value = "/imgs/light-small-logo.png";
      break;
    default:
      logoURL.value = "/imgs/dark-small-logo.png";
  }
});

function handleButton() {
  const expirationDate = new Date();
  expirationDate.setDate(expirationDate.getDate() + 7);

  localStorage.setItem(
    "banner-showed",
    JSON.stringify({
      value: true,
      expires: expirationDate,
    }),
  );
  showIcon.value = false;
}
</script>
<template>
  <div v-show="showIcon" class="container-banner">
    <div class="logo" :class="colorMode.preference">
      <svg
        width="70"
        height="58"
        viewBox="0 0 70 58"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M27.1845 0.728516L16.8204 19.078V0.728516H7.64563L0.849515 28.2528L0 31.311H7.64563L9.68447 23.3256L10.7039 19.078V31.311H17.8398L26.335 16.1897L22.4272 31.311H30.7524L38.2282 0.728516H27.1845Z"
          :fill="colorMode.preference === 'light' ? '#061922' : 'white'"
        />
        <path
          d="M68.1311 7.86444L70 0.728516H48.5923L36.3593 15.0004L40.4369 31.311H62.3544L64.9029 21.1169L67.4515 10.9227H54.1991L52.3301 18.0586H57.9369L56.7476 23.1557H46.3835L45.0243 17.2091L53.0097 7.86444H68.1311Z"
          :fill="colorMode.preference === 'light' ? '#061922' : 'white'"
        />
        <path
          d="M68.6407 36.748H6.45628L1.35919 57.4762H63.5437L68.6407 36.748Z"
          fill="#1C395C"
        />
        <path
          d="M39.9272 40.6543H31.2621L30.5825 43.3727H39.2476L39.9272 40.6543Z"
          fill="white"
        />
        <path
          d="M36.1893 44.3926L34.8301 49.8295H31.9417L33.1311 44.3926H30.4126L28.034 53.3974H36.699L38.9078 44.3926H36.1893Z"
          fill="white"
        />
        <path
          d="M53.0097 40.6543H49.2718L47.5728 43.3727H52.5L53.0097 40.6543Z"
          fill="white"
        />
        <path
          d="M45.3641 47.4508L45.534 44.3926H41.2864L39.0777 53.3974H41.7961L43.1553 47.9605L42.8155 53.3974H45.1942L47.9126 48.3003L46.5534 53.3974H49.9515L52.1602 44.3926H47.0631L45.3641 47.4508Z"
          fill="white"
        />
        <path
          d="M45.7039 40.6543H42.1359L41.4563 43.3727H45.534L45.7039 40.6543Z"
          fill="white"
        />
        <path
          d="M21.068 49.8291L20.5583 46.7708L23.4466 43.3727H28.3738L29.0534 40.6543H21.5777L16.9903 46.431L18.5194 53.397H25.8252L26.6748 49.8291H21.068Z"
          fill="white"
        />
      </svg>
    </div>
    <div class="content">
      <p class="title">{{ $t("more.app.modal_popup.title") }}</p>
      <p class="text">{{ $t("more.app.modal_popup.text") }}</p>
      <div class="link">
        <nuxt-link :href="`/${locale}/app`">
          <p class="big">{{ $t("more.app.modal_popup.action") }}</p>
          <p class="small">{{ $t("more.app.modal_popup.action") }}</p>
        </nuxt-link>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="15"
          viewBox="0 0 14 15"
          fill="none"
        >
          <g clip-path="url(#clip0_385_2627)">
            <path
              d="M9.78425 0.507006C9.7545 0.473756 8.68262 0.520131 7.74987 1.53251C6.81712 2.54401 6.96062 3.70426 6.98162 3.73401C7.00262 3.76376 8.31162 3.81013 9.14725 2.63326C9.98287 1.45638 9.814 0.541131 9.78425 0.507006ZM12.684 10.7734C12.642 10.6894 10.6496 9.69363 10.8351 7.77913C11.0206 5.86376 12.3007 5.33876 12.3209 5.28188C12.341 5.22501 11.7985 4.59063 11.2236 4.26951C10.8015 4.0431 10.3344 3.91339 9.856 3.88976C9.7615 3.88713 9.43337 3.80663 8.75875 3.99126C8.31425 4.11288 7.31237 4.50663 7.03675 4.52238C6.76025 4.53813 5.93775 4.06563 5.05312 3.94051C4.487 3.83113 3.88675 4.05513 3.45712 4.22751C3.02837 4.39901 2.21287 4.88726 1.64237 6.18488C1.07187 7.48163 1.37025 9.53613 1.58375 10.1749C1.79725 10.8128 2.13062 11.8584 2.69762 12.6214C3.20162 13.4824 3.87012 14.08 4.14925 14.283C4.42837 14.486 5.21587 14.6208 5.76187 14.3416C6.20112 14.0721 6.99387 13.9173 7.30712 13.9286C7.6195 13.94 8.2355 14.0634 8.86637 14.4003C9.366 14.5726 9.8385 14.5009 10.3119 14.3084C10.7852 14.115 11.4704 13.3818 12.2701 11.8951C12.5737 11.2039 12.712 10.8303 12.684 10.7734Z"
              :fill="colorMode.preference === 'light' ? '#0D0D0D' : 'white'"
            />
            <path
              d="M9.78425 0.507006C9.7545 0.473756 8.68262 0.520131 7.74987 1.53251C6.81712 2.54401 6.96062 3.70426 6.98162 3.73401C7.00262 3.76376 8.31162 3.81013 9.14725 2.63326C9.98287 1.45638 9.814 0.541131 9.78425 0.507006ZM12.684 10.7734C12.642 10.6894 10.6496 9.69363 10.8351 7.77913C11.0206 5.86376 12.3007 5.33876 12.3209 5.28188C12.341 5.22501 11.7985 4.59063 11.2236 4.26951C10.8015 4.0431 10.3344 3.91339 9.856 3.88976C9.7615 3.88713 9.43337 3.80663 8.75875 3.99126C8.31425 4.11288 7.31237 4.50663 7.03675 4.52238C6.76025 4.53813 5.93775 4.06563 5.05312 3.94051C4.487 3.83113 3.88675 4.05513 3.45712 4.22751C3.02837 4.39901 2.21287 4.88726 1.64237 6.18488C1.07187 7.48163 1.37025 9.53613 1.58375 10.1749C1.79725 10.8128 2.13062 11.8584 2.69762 12.6214C3.20162 13.4824 3.87012 14.08 4.14925 14.283C4.42837 14.486 5.21587 14.6208 5.76187 14.3416C6.20112 14.0721 6.99387 13.9173 7.30712 13.9286C7.6195 13.94 8.2355 14.0634 8.86637 14.4003C9.366 14.5726 9.8385 14.5009 10.3119 14.3084C10.7852 14.115 11.4704 13.3818 12.2701 11.8951C12.5737 11.2039 12.712 10.8303 12.684 10.7734Z"
              :fill="colorMode.preference === 'light' ? '#0D0D0D' : 'white'"
            />
          </g>
          <defs>
            <clipPath id="clip0_385_2627">
              <rect
                width="14"
                height="14"
                fill="white"
                transform="translate(0 0.5)"
              />
            </clipPath>
          </defs>
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="13"
          viewBox="0 0 12 13"
          fill="none"
        >
          <g clip-path="url(#clip0_385_2631)">
            <path
              d="M8.85047 8.46295C10.372 7.62749 11.5255 6.99088 11.6249 6.94138C11.943 6.77226 12.2714 6.3246 11.6249 5.97688C11.4162 5.86753 10.2923 5.25074 8.85047 4.45532L6.85162 6.47399L8.85047 8.4629V8.46295Z"
              fill="#FFD900"
            />
            <path
              d="M6.85173 6.47388L0.487183 12.8884C0.636573 12.9082 0.805229 12.8686 1.00407 12.7593C1.42154 12.5307 5.84711 10.1139 8.85057 8.4633L6.85173 6.47388Z"
              fill="#3378DD"
            />
            <path
              d="M6.85167 6.47393L8.85052 4.4652C8.85052 4.4652 1.45167 0.427338 1.00402 0.188978C0.835359 0.0890876 0.646359 0.0594157 0.477234 0.0890876L6.85167 6.47393Z"
              fill="#00EE76"
            />
            <path
              d="M6.85177 6.47396L0.477328 0.0891113C0.218625 0.148924 0 0.377486 0 0.844924V12.1327C0 12.5605 0.169172 12.8686 0.487219 12.8984L6.85177 6.47396Z"
              fill="#00D3FF"
            />
          </g>
          <defs>
            <clipPath id="clip0_385_2631">
              <rect
                width="12"
                height="12.8438"
                fill="white"
                transform="translate(0 0.078125)"
              />
            </clipPath>
          </defs>
        </svg>
      </div>
    </div>
    <img class="qrcode" src="/imgs/qrCode_app.png" width="70" height="56.75" />
    <button type="button" @click="handleButton">
      <MGIcon icon="close" />
    </button>
  </div>
</template>

<style lang="scss" scoped>
.container-banner {
  min-height: 8rem;
  border: 1px solid var(--banner-border-color);
  border-bottom: none;
  background: var(--banner-bg);
  display: flex;
  position: relative;
  transition:
    border ease 0.3s,
    background ease 0.3s;
}

button {
  position: absolute;
  top: 0;
  width: 2.125rem;
  height: 2.125rem;
  border-radius: 100%;
  background: var(--banner-button-bg);
  display: flex;
  transition: background ease 0.3s;
  align-items: center;
  justify-content: center;
  right: 0;
  transform: translate(50%, -50%);
  border: none;
  i {
    color: var(--section-title-fg);
    transition: color ease 0.3s;
  }
}

.qrcode {
  margin: 0.88rem 0;
  height: 6.25rem;
  width: 6.25rem;
  object-fit: contain;
  margin-right: 1.25rem;
}

.content {
  display: flex;
  flex-direction: column;
  padding-top: 1.25rem;
  padding-left: 1rem;
  padding-right: 1.5rem;
  padding-bottom: 1.25rem;
  p {
    margin: 0;
    &.title {
      font-size: 0.875rem;
      color: var(--section-title-fg);
      transition: color ease 0.3s;
    }
    &.text {
      color: #aaa;
      font-size: 0.75rem;
      margin-top: 0.5rem;
    }
  }
  .link {
    display: flex;
    column-gap: 0.5rem;
    margin-top: 0.75rem;
    a {
      font-size: 0.75rem;
      color: var(--banner-link-color);
      transition: color ease 0.3s;
      .big {
        display: block;
      }
      .small {
        display: none;
      }
    }
  }
}

.logo {
  height: 8rem;
  width: 8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    width: 70px;

    height: 56.75px;
  }
  &.light {
    background: linear-gradient(135deg, #eaedf0 0%, #c9d2dd 100%);
  }

  &.dark {
    background: linear-gradient(135deg, rgba(28, 57, 92, 0.1) 0%, #1c395c 100%);
  }
  transition: background ease 0.3s;
}

@media (max-width: 430px) {
  .content {
    padding-top: 1rem;
    padding-bottom: 1.12rem;
  }
  .logo {
    width: 5rem;
    height: 5rem;
    margin: 0.63rem 0;
    margin-left: 0.88rem;
    svg {
      width: 44px;
      height: 35.47px;
    }
  }
  .qrcode {
    display: none;
  }
  .content {
    p.text {
      margin-top: 0;
    }
  }
  .content .link {
    margin-top: 1rem;
    a {
      .big {
        display: none;
      }
      .small {
        display: block;
      }
    }
  }
  .container-banner {
    min-height: 6.25rem;
  }
}
</style>
